import { GTM_DEFAULT_DATA_LAYER } from 'config/constants'
import { USER_ID } from './../constants'

/**
 * 當是 web view 時，會呼叫 GtmAgent.setDisable(true)
 */
export const GtmAgent = (function () {
  let cache = []
  const flushCacheData = () => {
    for (const data of cache) {
      directSendToGTM(data)
    }
    cache = []
  }

  let isAuthEventSent = false
  const sendAuthEvent = (userId) => {
    isAuthEventSent = true
    directSendToGTM({ event: USER_ID, category: 'livingec', userId })
    if (isAuthEventSent && sidSettled) {
      flushCacheData()
    }
  }

  let sidSettled = false
  let sid = ''
  const setSID = (newSID) => {
    sid = newSID
    sidSettled = true
    if (isAuthEventSent && sidSettled) {
      flushCacheData()
    }
  }

  let disable = false
  const setDisable = (bool) => (disable = bool)

  // 確保 dataLayer 存在並推送資料
  const pushToDataLayer = (data) => {
    if (typeof window !== 'undefined') {
      window[GTM_DEFAULT_DATA_LAYER] = window[GTM_DEFAULT_DATA_LAYER] || []
      window[GTM_DEFAULT_DATA_LAYER].push(data)
    }
  }

  // 因 SID 關閉而暫時不會用到
  const sendToGTMAfterSID = (data) => {
    if (disable) {
      return
    }
    if (isAuthEventSent && sidSettled) {
      pushToDataLayer(data)
    } else {
      cache.push(data)
    }
  }

  const directSendToGTM = (data) => {
    if (disable) {
      return
    }
    pushToDataLayer(data)
  }

  return {
    setDisable,
    sendAuthEvent,
    setSID,
    sendToGTMAfterSID,
    directSendToGTM,
  }
})()
